// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1blnz","vLegacy":"SelectSecondary_vLegacy__3bE5K","error":"SelectSecondary_error__2baGQ","disabled":"SelectSecondary_disabled__30M5X"};